import { IntlShape, useIntl } from 'react-intl';
import { CashCompanyDropdown } from 'components/CashCompanyDropdown/CashCompanyDropdown';
import { DropdownOption } from 'components/Dropdown/types';
import { getStoreId } from 'components/StoreSelect/slice';
import { useAppSelector } from 'store/hooks';
import {
  createCashCompanyDropdown,
  findDefaultCashAccountOption
} from './helpers';
import { CashCompanies } from './types';

export const CashCompany = ({
  cashCompanies,
  isLoading,
  setSelectedCashCompany
}: {
  cashCompanies: CashCompanies[] | undefined;
  isLoading: boolean;
  setSelectedCashCompany: (option: DropdownOption) => void;
}): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const storeId = useAppSelector(getStoreId);

  const defaultOption = findDefaultCashAccountOption(
    storeId,
    cashCompanies,
    intl
  );
  const dropdownOptions = createCashCompanyDropdown(cashCompanies);

  return (
    <CashCompanyDropdown
      cashCompanyStores={dropdownOptions || []}
      setSelectedCashCompany={setSelectedCashCompany}
      isLoading={isLoading}
      defaultOption={defaultOption}
    />
  );
};
